"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;height:100%;background-color:", theme.color.monochrome.superLight, ";overflow:hidden;@media print{display:block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var contentContainer = function contentContainer(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;position:relative;width:100%;height:100%;flex-grow:1;background-color:", theme.color.mainNav.background, ";overflow:hidden;z-index:2;@media print{display:block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:contentContainer;"));
};

var childrenContainer = function childrenContainer(_ref) {
  var theme = _ref.theme,
      isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed;
  return /*#__PURE__*/(0, _react.css)("width:100%;min-width:0;background-color:", theme.color.globalNav.childrenContainerBackground, ";overflow:hidden auto;border-left:", isLeftSidebarCollapsed ? "1px solid ".concat(theme.color.monochrome.light) : 0, ";z-index:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:childrenContainer;"));
};

var leftSidebarContainer = function leftSidebarContainer(_ref2) {
  var theme = _ref2.theme,
      isCollapsed = _ref2.isCollapsed;
  return /*#__PURE__*/(0, _react.css)("position:relative;width:", isCollapsed ? 0 : '220px', ";min-height:100%;flex-shrink:0;transition:width 150ms;@media only screen and (max-width: ", theme.breakpoints.mediumMonitorBreakpoint, "){width:", isCollapsed ? 0 : '210px', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:leftSidebarContainer;"));
};

var leftSidebarHolder = function leftSidebarHolder(theme) {
  return /*#__PURE__*/(0, _react.css)("position:absolute;top:0;left:0;bottom:0;width:220px;@media only screen and (max-width: ", theme.breakpoints.mediumMonitorBreakpoint, "){width:210px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:leftSidebarHolder;"));
};

var mainAreaContainer = process.env.NODE_ENV === "production" ? {
  name: "xql3ha",
  styles: "display:flex;flex-direction:column;width:100%;height:100%;min-width:0;@media print{display:block;}"
} : {
  name: "1adyfz3-mainAreaContainer",
  styles: "display:flex;flex-direction:column;width:100%;height:100%;min-width:0;@media print{display:block;};label:mainAreaContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  base: base,
  contentContainer: contentContainer,
  childrenContainer: childrenContainer,
  leftSidebarContainer: leftSidebarContainer,
  leftSidebarHolder: leftSidebarHolder,
  mainAreaContainer: mainAreaContainer
};
exports.styles = styles;
//# sourceMappingURL=WithGlobalNav.styles.js.map